import { Chip, Icon, TextEllipsis, ViewMore } from '@aibees/shared/components';
import { trimText } from '@aibees/shared/utils';
import { Box, OutlinedInput, OutlinedInputProps } from '@mui/material';
import { SearchFilter } from '../types';

export function renderTags({
  tagsList,
  utils,
  metadata,
  onDelete,
  error,
}: {
  tagsList: string[];
  utils?: SearchFilter['utils'];
  metadata?: SearchFilter['metadata'];
  onDelete?: (e: React.MouseEvent<HTMLDivElement>, v: string) => void;
  error?: boolean;
}) {
  const tags = tagsList.map((option) => {
    const text = utils?.tags?.labelFormatter
      ? utils?.tags?.labelFormatter(option, option, {
          delimiter: metadata?.delimiter,
        })
      : option;

    const trimmedText = trimText(text, 150);
    return (
      <Chip
        key={option}
        variant="outlined"
        size="xsmall"
        color={error ? 'error' : metadata?.color ?? 'default'}
        icon={
          metadata?.icon ? (
            <Icon size={12} name={metadata?.icon} color={metadata?.color} />
          ) : undefined
        }
        deleteIcon={<Icon size={12} name="close" color="default" />}
        label={
          <Box display="flex" alignItems="center">
            <TextEllipsis
              variant="body5"
              color="grey.700"
              value={trimmedText}
              w="150px"
            />
          </Box>
        }
        onDelete={(e) => onDelete?.(e, option)}
      />
    );
  });
  return (
    <ViewMore
      limit={3}
      displayTags={3}
      list={tags}
      buttonProps={{
        variant: 'soft',
        size: 'xsmall',
        color: 'primary',
      }}
    />
  );
}

export function renderInput({
  field,
  search,
  onChange,
  onKeyUp,
  onKeyDown,
  onBlur,
  onFocus,
  placeholder,
  error,
}: {
  field: string;
  search: string;
  onChange: (value: string) => void;
  onKeyUp?: OutlinedInputProps['onKeyUp'];
  onKeyDown?: OutlinedInputProps['onKeyDown'];
  onBlur?: OutlinedInputProps['onBlur'];
  onFocus?: OutlinedInputProps['onFocus'];
  placeholder?: string;
  error?: boolean;
}) {
  return (
    <OutlinedInput
      inputProps={{
        ...{
          id: field,
          value: search,
          autoComplete: 'off',
          'aria-autocomplete': 'none',
        },
      }}
      aria-autocomplete="none"
      size="small"
      fullWidth
      onChange={(e) => onChange(e.currentTarget.value)}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      sx={{ border: 'none', boxShadow: 'none!important' }}
      onBlur={onBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      autoComplete="off"
      onClick={(e) => {
        const node = (e.target as HTMLElement).nodeName;
        if (node === 'path' || node === 'svg') onChange('');
      }}
    />
  );
}
